module.exports = __webpack_public_path__ + "img/loading.738c4eac.gif";